/** Generated from canonical schemas.json + operations.json. Do not edit. */
import type { components } from "./openapi-types.js";
import { assertApiValue, ApiContractValidationError } from "./validation.js";
import type { ApiSchemaName } from "./validation.js";

export interface ApiOperationInputs {
  getSession: {  };
  listCalendars: {  };
  createCalendar: { body: components["schemas"]["CreateCalendar"] };
  getMonth: { path: { "calendarId": components["schemas"]["Id"] }; query: { "month": components["schemas"]["MonthKey"] } };
  getDayEntries: { path: { "calendarId": components["schemas"]["Id"]; "dayKey": components["schemas"]["DayKey"] }; query?: { "limit"?: number; "cursor"?: string } };
  getMyPendingEntries: { path: { "calendarId": components["schemas"]["Id"] }; query?: { "cursor"?: string } };
  createDraft: { path: { "calendarId": components["schemas"]["Id"] }; headers: { "Idempotency-Key": string }; body: components["schemas"]["CreateDraft"] };
  getEntry: { path: { "entryId": components["schemas"]["Id"] } };
  editEntry: { path: { "entryId": components["schemas"]["Id"] }; body: components["schemas"]["EditEntry"] };
  deleteEntry: { path: { "entryId": components["schemas"]["Id"] }; query: { "expectedRevision": number } };
  requestPublication: { path: { "entryId": components["schemas"]["Id"] }; headers: { "Idempotency-Key": string }; body: components["schemas"]["RevisionRequest"] };
  cancelPublication: { path: { "entryId": components["schemas"]["Id"] }; body: components["schemas"]["RevisionRequest"] };
  reserveUpload: { path: { "entryId": components["schemas"]["Id"] }; headers: { "Idempotency-Key": string }; body: components["schemas"]["UploadReservation"] };
  getUpload: { path: { "uploadId": components["schemas"]["Id"] } };
  completeUpload: { path: { "uploadId": components["schemas"]["Id"] }; body: components["schemas"]["UploadComplete"] };
  cancelUpload: { path: { "uploadId": components["schemas"]["Id"] }; body: components["schemas"]["UploadCancel"] };
  resolveMediaAccess: { body: components["schemas"]["MediaAccessRequest"] };
  listMembers: { path: { "calendarId": components["schemas"]["Id"] }; query?: { "cursor"?: string } };
  inviteMember: { path: { "calendarId": components["schemas"]["Id"] }; body: components["schemas"]["InviteRequest"] };
  acceptInvite: { body: components["schemas"]["AcceptInvite"] };
  changeMemberRole: { path: { "calendarId": components["schemas"]["Id"]; "userId": components["schemas"]["Id"] }; body: components["schemas"]["ChangeRole"] };
  revokeMember: { path: { "calendarId": components["schemas"]["Id"]; "userId": components["schemas"]["Id"] } };
  streamWebhook: { body: unknown };
  liveness: {  };
  readiness: {  };
  socialCapabilities: {  };
  socialMe: {  };
  saveSocialProfile: { body: components["schemas"]["SocialProfileInput"] };
  searchSocialPeople: { query?: { "search"?: string; "cursor"?: string; "limit"?: number } };
  getSocialProfile: { path: { "userId": components["schemas"]["Id"] } };
  followSocialPerson: { path: { "userId": components["schemas"]["Id"] } };
  unfollowSocialPerson: { path: { "userId": components["schemas"]["Id"] } };
  socialFollowers: { path: { "userId": components["schemas"]["Id"] }; query?: { "cursor"?: string; "limit"?: number } };
  socialFollowing: { path: { "userId": components["schemas"]["Id"] }; query?: { "cursor"?: string; "limit"?: number } };
  socialMonth: { query: { "month": components["schemas"]["MonthKey"]; "filter"?: "everyone" | "following"; "groupId"?: components["schemas"]["SocialId"] } };
  socialDayPosts: { path: { "dayKey": components["schemas"]["DayKey"] }; query?: { "filter"?: "everyone" | "following"; "cursor"?: string; "limit"?: number; "groupId"?: components["schemas"]["SocialId"] } };
  socialFollowingActivity: { query?: { "cursor"?: string; "limit"?: number; "after"?: string; "groupId"?: components["schemas"]["SocialId"] } };
  createSocialDailyGrid: { headers: { "Idempotency-Key": string }; body: components["schemas"]["SocialCreateDailyInput"] };
  getOwnSocialDailyGrid: { query: { "day": components["schemas"]["DayKey"] } };
  getSocialProfileGrid: { path: { "userId": components["schemas"]["Id"] } };
  readSocialGrid: { path: { "gridId": components["schemas"]["SocialId"] }; query?: { "groupId"?: components["schemas"]["SocialId"] } };
  deleteSocialGrid: { path: { "gridId": components["schemas"]["SocialId"] }; query: { "expectedRevision": number; "groupId"?: components["schemas"]["SocialId"] } };
  getSocialWorkingGrid: { path: { "gridId": components["schemas"]["SocialId"] } };
  saveSocialGridDraft: { path: { "gridId": components["schemas"]["SocialId"] }; body: components["schemas"]["SocialDraftInput"] };
  submitSocialGrid: { path: { "gridId": components["schemas"]["SocialId"] }; headers: { "Idempotency-Key": string }; body: components["schemas"]["RevisionRequest"] };
  getSocialSubmission: { path: { "submissionId": components["schemas"]["SocialId"] } };
  discardSocialGridDraft: { path: { "gridId": components["schemas"]["SocialId"] }; body: components["schemas"]["RevisionRequest"] };
  reserveSocialGridUpload: { path: { "gridId": components["schemas"]["SocialId"] }; headers: { "Idempotency-Key": string }; body: components["schemas"]["SocialUploadReservation"] };
  reserveSocialAvatarUpload: { headers: { "Idempotency-Key": string }; body: components["schemas"]["UploadReservation"] };
  getSocialUpload: { path: { "uploadId": components["schemas"]["SocialId"] } };
  completeSocialUpload: { path: { "uploadId": components["schemas"]["SocialId"] }; body: components["schemas"]["EmptyObject"] };
  cancelSocialUpload: { path: { "uploadId": components["schemas"]["SocialId"] }; body: components["schemas"]["EmptyObject"] };
  socialMediaAccess: { body: components["schemas"]["SocialMediaAccessRequest"] };
  setSocialAvatar: { body: components["schemas"]["SocialAvatarInput"] };
  removeSocialAvatar: { query: { "expectedRevision": number } };
  getSocialMediaCapabilities: {  };
  socialAppearance: {  };
  socialGroups: { query?: { "limit"?: number; "cursor"?: string } };
  socialCreateGroup: { headers: { "Idempotency-Key": string }; body: components["schemas"]["SocialGroupCreateInput"] };
  socialGroup: { path: { "groupId": components["schemas"]["SocialId"] } };
  socialGroupMembers: { path: { "groupId": components["schemas"]["SocialId"] }; query?: { "limit"?: number; "cursor"?: string } };
  socialInviteGroupMember: { path: { "groupId": components["schemas"]["SocialId"] }; body: components["schemas"]["SocialGroupInviteInput"] };
  socialGroupInvitations: { query?: { "limit"?: number; "cursor"?: string } };
  socialAcceptGroupInvitation: { path: { "invitationId": components["schemas"]["SocialId"] }; body: components["schemas"]["EmptyObject"] };
  socialRevokeGroupInvitation: { path: { "invitationId": components["schemas"]["SocialId"] } };
  socialRemoveGroupMember: { path: { "groupId": components["schemas"]["SocialId"]; "userId": components["schemas"]["Id"] }; body: components["schemas"]["RevisionRequest"] };
  socialLeaveGroup: { path: { "groupId": components["schemas"]["SocialId"] }; body: components["schemas"]["RevisionRequest"] };
  socialTransferGroup: { path: { "groupId": components["schemas"]["SocialId"] }; body: components["schemas"]["SocialGroupInviteInput"] };
}
export interface ApiOperationOutputs {
  getSession: components["schemas"]["Session"];
  listCalendars: components["schemas"]["CalendarList"];
  createCalendar: components["schemas"]["Calendar"];
  getMonth: components["schemas"]["MonthSummary"];
  getDayEntries: components["schemas"]["EntryPage"];
  getMyPendingEntries: components["schemas"]["PendingEntries"];
  createDraft: components["schemas"]["OwnerEntry"];
  getEntry: components["schemas"]["EntryRead"];
  editEntry: components["schemas"]["OwnerEntry"];
  deleteEntry: void;
  requestPublication: components["schemas"]["OwnerEntry"];
  cancelPublication: components["schemas"]["OwnerEntry"];
  reserveUpload: components["schemas"]["UploadStatus"];
  getUpload: components["schemas"]["UploadStatus"];
  completeUpload: components["schemas"]["UploadStatus"];
  cancelUpload: components["schemas"]["OwnerEntry"];
  resolveMediaAccess: components["schemas"]["MediaAccessResponse"];
  listMembers: components["schemas"]["MemberList"];
  inviteMember: components["schemas"]["InviteResponse"];
  acceptInvite: components["schemas"]["Calendar"];
  changeMemberRole: components["schemas"]["Member"];
  revokeMember: void;
  streamWebhook: void;
  liveness: components["schemas"]["Health"];
  readiness: components["schemas"]["Health"];
  socialCapabilities: components["schemas"]["SocialAuthCapabilities"];
  socialMe: components["schemas"]["SocialMe"];
  saveSocialProfile: components["schemas"]["SocialMe"];
  searchSocialPeople: components["schemas"]["SocialPeoplePage"];
  getSocialProfile: components["schemas"]["SocialProfile"];
  followSocialPerson: components["schemas"]["SocialProfile"];
  unfollowSocialPerson: components["schemas"]["SocialProfile"];
  socialFollowers: components["schemas"]["SocialPeoplePage"];
  socialFollowing: components["schemas"]["SocialPeoplePage"];
  socialMonth: components["schemas"]["SocialMonth"];
  socialDayPosts: components["schemas"]["SocialPostPage"];
  socialFollowingActivity: components["schemas"]["SocialActivityPage"];
  createSocialDailyGrid: components["schemas"]["SocialOwnerGrid"];
  getOwnSocialDailyGrid: components["schemas"]["SocialOwnGridLookup"];
  getSocialProfileGrid: components["schemas"]["SocialGridRead"];
  readSocialGrid: components["schemas"]["SocialGridRead"];
  deleteSocialGrid: void;
  getSocialWorkingGrid: components["schemas"]["SocialOwnerGrid"];
  saveSocialGridDraft: components["schemas"]["SocialOwnerGrid"];
  submitSocialGrid: components["schemas"]["SocialSubmission"];
  getSocialSubmission: components["schemas"]["SocialSubmission"];
  discardSocialGridDraft: components["schemas"]["SocialOwnerGrid"];
  reserveSocialGridUpload: components["schemas"]["SocialUploadStatus"];
  reserveSocialAvatarUpload: components["schemas"]["SocialUploadStatus"];
  getSocialUpload: components["schemas"]["SocialUploadStatus"];
  completeSocialUpload: components["schemas"]["SocialUploadStatus"];
  cancelSocialUpload: components["schemas"]["SocialUploadStatus"];
  socialMediaAccess: components["schemas"]["SocialMediaAccessResponse"];
  setSocialAvatar: components["schemas"]["SocialMe"];
  removeSocialAvatar: components["schemas"]["SocialMe"];
  getSocialMediaCapabilities: components["schemas"]["SocialMediaCapabilities"];
  socialAppearance: components["schemas"]["SocialAppearanceOptions"];
  socialGroups: components["schemas"]["SocialGroupPage"];
  socialCreateGroup: components["schemas"]["SocialGroup"];
  socialGroup: components["schemas"]["SocialGroup"];
  socialGroupMembers: components["schemas"]["SocialGroupMembers"];
  socialInviteGroupMember: components["schemas"]["SocialGroupInvitation"];
  socialGroupInvitations: components["schemas"]["SocialGroupInvitations"];
  socialAcceptGroupInvitation: components["schemas"]["SocialGroup"];
  socialRevokeGroupInvitation: void;
  socialRemoveGroupMember: components["schemas"]["SocialGroup"];
  socialLeaveGroup: void;
  socialTransferGroup: components["schemas"]["SocialGroup"];
}
export type ApiOperationId = keyof ApiOperationInputs;
const operationPlans = {
  "getSession": {
    "method": "GET",
    "path": "/api/session",
    "responseSchemas": {
      "200": "Session"
    }
  },
  "listCalendars": {
    "method": "GET",
    "path": "/api/calendars",
    "responseSchemas": {
      "200": "CalendarList"
    }
  },
  "createCalendar": {
    "method": "POST",
    "path": "/api/calendars",
    "responseSchemas": {
      "201": "Calendar"
    }
  },
  "getMonth": {
    "method": "GET",
    "path": "/api/calendars/{calendarId}/month",
    "responseSchemas": {
      "200": "MonthSummary"
    }
  },
  "getDayEntries": {
    "method": "GET",
    "path": "/api/calendars/{calendarId}/days/{dayKey}/entries",
    "responseSchemas": {
      "200": "EntryPage"
    }
  },
  "getMyPendingEntries": {
    "method": "GET",
    "path": "/api/calendars/{calendarId}/pending-entries",
    "responseSchemas": {
      "200": "PendingEntries"
    }
  },
  "createDraft": {
    "method": "POST",
    "path": "/api/calendars/{calendarId}/entries/drafts",
    "responseSchemas": {
      "201": "OwnerEntry"
    }
  },
  "getEntry": {
    "method": "GET",
    "path": "/api/entries/{entryId}",
    "responseSchemas": {
      "200": "EntryRead"
    }
  },
  "editEntry": {
    "method": "PATCH",
    "path": "/api/entries/{entryId}",
    "responseSchemas": {
      "200": "OwnerEntry"
    }
  },
  "deleteEntry": {
    "method": "DELETE",
    "path": "/api/entries/{entryId}",
    "responseSchemas": {
      "204": null
    }
  },
  "requestPublication": {
    "method": "POST",
    "path": "/api/entries/{entryId}/publish",
    "responseSchemas": {
      "200": "OwnerEntry",
      "202": "OwnerEntry"
    }
  },
  "cancelPublication": {
    "method": "POST",
    "path": "/api/entries/{entryId}/cancel-publication",
    "responseSchemas": {
      "200": "OwnerEntry"
    }
  },
  "reserveUpload": {
    "method": "POST",
    "path": "/api/entries/{entryId}/uploads",
    "responseSchemas": {
      "201": "UploadStatus"
    }
  },
  "getUpload": {
    "method": "GET",
    "path": "/api/uploads/{uploadId}",
    "responseSchemas": {
      "200": "UploadStatus"
    }
  },
  "completeUpload": {
    "method": "POST",
    "path": "/api/uploads/{uploadId}/complete",
    "responseSchemas": {
      "202": "UploadStatus"
    }
  },
  "cancelUpload": {
    "method": "POST",
    "path": "/api/uploads/{uploadId}/cancel",
    "responseSchemas": {
      "200": "OwnerEntry"
    }
  },
  "resolveMediaAccess": {
    "method": "POST",
    "path": "/api/media/access",
    "responseSchemas": {
      "200": "MediaAccessResponse"
    }
  },
  "listMembers": {
    "method": "GET",
    "path": "/api/calendars/{calendarId}/members",
    "responseSchemas": {
      "200": "MemberList"
    }
  },
  "inviteMember": {
    "method": "POST",
    "path": "/api/calendars/{calendarId}/invitations",
    "responseSchemas": {
      "201": "InviteResponse"
    }
  },
  "acceptInvite": {
    "method": "POST",
    "path": "/api/invitations/accept",
    "responseSchemas": {
      "200": "Calendar"
    }
  },
  "changeMemberRole": {
    "method": "PATCH",
    "path": "/api/calendars/{calendarId}/members/{userId}",
    "responseSchemas": {
      "200": "Member"
    }
  },
  "revokeMember": {
    "method": "DELETE",
    "path": "/api/calendars/{calendarId}/members/{userId}",
    "responseSchemas": {
      "204": null
    }
  },
  "streamWebhook": {
    "method": "POST",
    "path": "/api/webhooks/stream",
    "responseSchemas": {
      "204": null
    }
  },
  "liveness": {
    "method": "GET",
    "path": "/api/health/live",
    "responseSchemas": {
      "200": "Health"
    }
  },
  "readiness": {
    "method": "GET",
    "path": "/api/health/ready",
    "responseSchemas": {
      "200": "Health"
    }
  },
  "socialCapabilities": {
    "method": "GET",
    "path": "/api/social/capabilities",
    "responseSchemas": {
      "200": "SocialAuthCapabilities"
    }
  },
  "socialMe": {
    "method": "GET",
    "path": "/api/social/me",
    "responseSchemas": {
      "200": "SocialMe"
    }
  },
  "saveSocialProfile": {
    "method": "PUT",
    "path": "/api/social/me/profile",
    "responseSchemas": {
      "200": "SocialMe"
    }
  },
  "searchSocialPeople": {
    "method": "GET",
    "path": "/api/social/people",
    "responseSchemas": {
      "200": "SocialPeoplePage"
    }
  },
  "getSocialProfile": {
    "method": "GET",
    "path": "/api/social/people/{userId}",
    "responseSchemas": {
      "200": "SocialProfile"
    }
  },
  "followSocialPerson": {
    "method": "PUT",
    "path": "/api/social/people/{userId}/follow",
    "responseSchemas": {
      "200": "SocialProfile"
    }
  },
  "unfollowSocialPerson": {
    "method": "DELETE",
    "path": "/api/social/people/{userId}/follow",
    "responseSchemas": {
      "200": "SocialProfile"
    }
  },
  "socialFollowers": {
    "method": "GET",
    "path": "/api/social/people/{userId}/followers",
    "responseSchemas": {
      "200": "SocialPeoplePage"
    }
  },
  "socialFollowing": {
    "method": "GET",
    "path": "/api/social/people/{userId}/following",
    "responseSchemas": {
      "200": "SocialPeoplePage"
    }
  },
  "socialMonth": {
    "method": "GET",
    "path": "/api/social/calendar/month",
    "responseSchemas": {
      "200": "SocialMonth"
    }
  },
  "socialDayPosts": {
    "method": "GET",
    "path": "/api/social/calendar/days/{dayKey}/posts",
    "responseSchemas": {
      "200": "SocialPostPage"
    }
  },
  "socialFollowingActivity": {
    "method": "GET",
    "path": "/api/social/following/activity",
    "responseSchemas": {
      "200": "SocialActivityPage"
    }
  },
  "createSocialDailyGrid": {
    "method": "POST",
    "path": "/api/social/me/daily-grid",
    "responseSchemas": {
      "200": "SocialOwnerGrid",
      "201": "SocialOwnerGrid"
    }
  },
  "getOwnSocialDailyGrid": {
    "method": "GET",
    "path": "/api/social/me/daily-grid",
    "responseSchemas": {
      "200": "SocialOwnGridLookup"
    }
  },
  "getSocialProfileGrid": {
    "method": "GET",
    "path": "/api/social/people/{userId}/profile-grid",
    "responseSchemas": {
      "200": "SocialGridRead"
    }
  },
  "readSocialGrid": {
    "method": "GET",
    "path": "/api/social/grids/{gridId}",
    "responseSchemas": {
      "200": "SocialGridRead"
    }
  },
  "deleteSocialGrid": {
    "method": "DELETE",
    "path": "/api/social/grids/{gridId}",
    "responseSchemas": {
      "204": null
    }
  },
  "getSocialWorkingGrid": {
    "method": "GET",
    "path": "/api/social/grids/{gridId}/working",
    "responseSchemas": {
      "200": "SocialOwnerGrid"
    }
  },
  "saveSocialGridDraft": {
    "method": "PATCH",
    "path": "/api/social/grids/{gridId}/draft",
    "responseSchemas": {
      "200": "SocialOwnerGrid"
    }
  },
  "submitSocialGrid": {
    "method": "POST",
    "path": "/api/social/grids/{gridId}/submit",
    "responseSchemas": {
      "200": "SocialSubmission"
    }
  },
  "getSocialSubmission": {
    "method": "GET",
    "path": "/api/social/submissions/{submissionId}",
    "responseSchemas": {
      "200": "SocialSubmission"
    }
  },
  "discardSocialGridDraft": {
    "method": "POST",
    "path": "/api/social/grids/{gridId}/discard",
    "responseSchemas": {
      "200": "SocialOwnerGrid"
    }
  },
  "reserveSocialGridUpload": {
    "method": "POST",
    "path": "/api/social/grids/{gridId}/uploads",
    "responseSchemas": {
      "201": "SocialUploadStatus"
    }
  },
  "reserveSocialAvatarUpload": {
    "method": "POST",
    "path": "/api/social/me/avatar/uploads",
    "responseSchemas": {
      "201": "SocialUploadStatus"
    }
  },
  "getSocialUpload": {
    "method": "GET",
    "path": "/api/social/uploads/{uploadId}",
    "responseSchemas": {
      "200": "SocialUploadStatus"
    }
  },
  "completeSocialUpload": {
    "method": "POST",
    "path": "/api/social/uploads/{uploadId}/complete",
    "responseSchemas": {
      "202": "SocialUploadStatus"
    }
  },
  "cancelSocialUpload": {
    "method": "POST",
    "path": "/api/social/uploads/{uploadId}/cancel",
    "responseSchemas": {
      "200": "SocialUploadStatus"
    }
  },
  "socialMediaAccess": {
    "method": "POST",
    "path": "/api/social/media/access",
    "responseSchemas": {
      "200": "SocialMediaAccessResponse"
    }
  },
  "setSocialAvatar": {
    "method": "PUT",
    "path": "/api/social/me/avatar",
    "responseSchemas": {
      "200": "SocialMe"
    }
  },
  "removeSocialAvatar": {
    "method": "DELETE",
    "path": "/api/social/me/avatar",
    "responseSchemas": {
      "200": "SocialMe"
    }
  },
  "getSocialMediaCapabilities": {
    "method": "GET",
    "path": "/api/social/media/capabilities",
    "responseSchemas": {
      "200": "SocialMediaCapabilities"
    }
  },
  "socialAppearance": {
    "method": "GET",
    "path": "/api/social/appearance",
    "responseSchemas": {
      "200": "SocialAppearanceOptions"
    }
  },
  "socialGroups": {
    "method": "GET",
    "path": "/api/social/groups",
    "responseSchemas": {
      "200": "SocialGroupPage"
    }
  },
  "socialCreateGroup": {
    "method": "POST",
    "path": "/api/social/groups",
    "responseSchemas": {
      "200": "SocialGroup"
    }
  },
  "socialGroup": {
    "method": "GET",
    "path": "/api/social/groups/{groupId}",
    "responseSchemas": {
      "200": "SocialGroup"
    }
  },
  "socialGroupMembers": {
    "method": "GET",
    "path": "/api/social/groups/{groupId}/members",
    "responseSchemas": {
      "200": "SocialGroupMembers"
    }
  },
  "socialInviteGroupMember": {
    "method": "POST",
    "path": "/api/social/groups/{groupId}/invitations",
    "responseSchemas": {
      "200": "SocialGroupInvitation"
    }
  },
  "socialGroupInvitations": {
    "method": "GET",
    "path": "/api/social/me/group-invitations",
    "responseSchemas": {
      "200": "SocialGroupInvitations"
    }
  },
  "socialAcceptGroupInvitation": {
    "method": "POST",
    "path": "/api/social/group-invitations/{invitationId}/accept",
    "responseSchemas": {
      "200": "SocialGroup"
    }
  },
  "socialRevokeGroupInvitation": {
    "method": "DELETE",
    "path": "/api/social/group-invitations/{invitationId}",
    "responseSchemas": {
      "204": null
    }
  },
  "socialRemoveGroupMember": {
    "method": "DELETE",
    "path": "/api/social/groups/{groupId}/members/{userId}",
    "responseSchemas": {
      "200": "SocialGroup"
    }
  },
  "socialLeaveGroup": {
    "method": "POST",
    "path": "/api/social/groups/{groupId}/leave",
    "responseSchemas": {
      "204": null
    }
  },
  "socialTransferGroup": {
    "method": "PUT",
    "path": "/api/social/groups/{groupId}/owner",
    "responseSchemas": {
      "200": "SocialGroup"
    }
  }
} as const;

/** HTTP status and payload only. Callers map errors into their own behavior. */
export class ApiHttpError extends Error {
  constructor(readonly status: number, readonly payload: unknown) {
    super(`API request failed with status ${status}.`);
    this.name = "ApiHttpError";
  }
}
export interface ApiClient {
  request<Operation extends ApiOperationId>(operation: Operation, input: ApiOperationInputs[Operation], options?: { readonly signal?: AbortSignal }): Promise<ApiOperationOutputs[Operation]>;
}

/** Transport only: no cache, router, authorization, retry, or publication policy. */
export function createApiClient(transport: typeof fetch = globalThis.fetch, baseUrl = ""): ApiClient {
  return {
    async request<Operation extends ApiOperationId>(operation: Operation, input: ApiOperationInputs[Operation], options?: { readonly signal?: AbortSignal }): Promise<ApiOperationOutputs[Operation]> {
      const plan = operationPlans[operation];
      const values = input as { path?: Record<string, string>; query?: Record<string, string | number | boolean | undefined>; headers?: Record<string, string>; body?: unknown };
      const route = plan.path.replace(/\{([^}]+)\}/g, (_match, key: string) => {
        const value = values.path?.[key];
        if (value === undefined) throw new TypeError(`Missing path parameter ${key}.`);
        return encodeURIComponent(value);
      });
      const query = new URLSearchParams();
      for (const [key, value] of Object.entries(values.query ?? {})) {
        if (value !== undefined) query.set(key, String(value));
      }
      const headers = new Headers(values.headers);
      const body = values.body === undefined ? undefined : JSON.stringify(values.body);
      if (body !== undefined) headers.set("Content-Type", "application/json");
      const init: RequestInit = { method: plan.method, credentials: "same-origin", headers };
      if (body !== undefined) init.body = body;
      if (options?.signal !== undefined) init.signal = options.signal;
      const response = await transport(baseUrl + route + (query.size ? "?" + query.toString() : ""), init);
      const text = await response.text();
      const responseSchemas: Readonly<Record<string, ApiSchemaName | null>> = plan.responseSchemas;
      const expectedSchema = response.ok ? responseSchemas[String(response.status)] : "Error";
      let payload: unknown;
      try {
        payload = text.length ? JSON.parse(text) : undefined;
      } catch {
        throw new ApiContractValidationError(expectedSchema ?? "Error", [{ instancePath: "", schemaPath: "", keyword: "type", params: { type: "JSON" }, message: "must contain valid JSON" }]);
      }
      if (!response.ok) {
        assertApiValue("Error", payload);
        throw new ApiHttpError(response.status, payload);
      }
      if (expectedSchema === undefined) {
        throw new ApiContractValidationError("Error", [{ instancePath: "", schemaPath: "", keyword: "enum", params: { allowedValues: Object.keys(responseSchemas) }, message: "must use a documented success status" }]);
      }
      if (expectedSchema === null) {
        if (payload !== undefined) throw new ApiContractValidationError("Error", [{ instancePath: "", schemaPath: "", keyword: "type", params: { type: "empty" }, message: "must not contain a response body" }]);
      } else {
        assertApiValue(expectedSchema, payload);
      }
      return payload as ApiOperationOutputs[Operation];
    },
  };
}
